export default __webpack_public_path__ + "static/media/delete.22ba6e00.svg";